/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AppstoreControllerFindStoreBannersResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    banners: {
      /** 스토어 배너 ID */
      id: string;
      /** 스토어 배너 제목 */
      title: string;
      /** 배너 클릭 시 이동 링크 */
      moveLink?: string;
      /** 배너 이미지 URL */
      imageUrl?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerFindListResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    apps: {
      _id: string;
      name: string;
      description?: string[];
      introduction?: string;
      clientDescription?: string;
      unitPrice: number;
      codeName: "ai-coach" | "ai-global-coordinator" | "ai-call-manager";
      status: "PENDING" | "PROCESSING" | "APPROVED" | "ACTIVE" | "INACTIVE";
      thumbnailPath?: string;
      appSettings?: {
        isApproved: boolean;
        isSetupCompleted: boolean;
        isUsingReservation?: boolean;
        settings?: AiCoachResponse | AiGlobalCoordinatorResponse | AiCallManagerResponse | null;
      };
      subscription?: {
        isActive: boolean;
        activatedAt?: string;
        inactivatedAt?: string;
      };
      modifier?: {
        userID: string;
        name: string;
        realName: string;
        type?: number;
        jobType?: string;
      };
      trial?: {
        /** 체험판 사용 가능 여부 */
        isAvailable: boolean;
        /** 체험판 제목 텍스트 */
        trialTitle?: string | null;
        /** 체험판 본문 텍스트 */
        trialBody?: string | null;
        /** 체험판 혜택 조건 */
        benefit?: {
          /** 최대 할인 금액 (원) */
          amountOff: number;
          /** 할인율 (%) */
          percentOff: number;
          /** 설명 */
          description?: string | null;
          /** 체험 기간 (일) */
          durationDays: number;
        };
      };
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AiCoachResponse {
  /** AI 자동 답변 시점 - 단위 : 분 */
  automaticResponseIntervalMinutes?: number;
  /** 운영시간 기반 시간대별 자동응대 정책 - 미설정 시 automaticResponseIntervalMinutes 단일값 동작 */
  automaticResponsePolicy?: {
    /** 운영시간 내 정책 */
    within: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
    /** 운영시간 외(퇴근 후·휴무일) 정책 */
    outside: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
  };
  /** AI 자동 답변 적용 대상 - 전체 채널 적용 여부 */
  automaticResponseAppliedToAllChannels: boolean;
  /** AI 응대 안내문구 사용 여부 */
  isUsingAiResponseNotice?: boolean;
  /**
   * AI 응대 안내문구 - 기본값 : 안녕하세요. AI 상담사입니다. 빠른 상담을 위해 제가 먼저 도와드릴게요.
   * 확인이 필요한 내용은 담당자에게 전달해 드리겠습니다.
   * @minLength 1
   * @maxLength 200
   */
  aiResponseNoticeMessage?: string;
  /** AI 자동 답변 적용 대상 - 채널 목록, 저장 어떻게 할지 안정해짐 */
  automaticResponseAppliedChannels: {
    _id: string;
    type: "afterdoc" | "ikakao" | "line" | "instagram" | "talktalk" | "wechat" | "whatsapp";
    enabled: boolean;
    name: string;
  }[];
  /** AI 응대 안내문구 기본값 (읽기 전용) */
  defaultAiResponseNoticeMessage: string;
}

export interface AiGlobalCoordinatorResponse {
  /** 부재 시 외국어로 자동 답변 여부 - 모든 언어 적용 여부 */
  automaticResponseAppliedToAllLanguages?: boolean;
  automaticResponseIntervalMinutes: number;
  /** 운영시간 기반 시간대별 자동응대 정책 - 미설정 시 automaticResponseIntervalMinutes 단일값 동작 */
  automaticResponsePolicy?: {
    /** 운영시간 내 정책 */
    within: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
    /** 운영시간 외(퇴근 후·휴무일) 정책 */
    outside: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
  };
  /** 자동 응대할 언어 설정 목록, languageID 모음. */
  automaticResponseAppliedLanguages: string[];
  automaticResponseSupportedLanguages: {
    _id: string;
    name: string;
  }[];
}

export interface AiCallManagerResponse {
  hospitalId?: string;
  autoResponseSecond?: number;
  /** @default true */
  isUsingDirectCallRecord?: boolean;
  phoneNumberMappings?: {
    /** 매핑 고유 ID */
    _id: string;
    /** 매핑 별칭 (Admin 관리용) */
    name?: string;
    /** 병원 대표번호 (E.164) */
    hospitalMainNumber: string;
    /** Twilio AI 수신번호 (E.164) */
    twilioIncomingPhoneNumber: string;
    /** 직원 수신 전화번호 목록 (E.164[]) */
    phoneLineNumbers: string[];
    /** 알림 지정 대상(전화 문의 담당자) 계정 ID 목록 */
    notificationRecipientIds?: string[];
    /** 매핑 수정일시 */
    updatedAt?: string | null;
  }[];
}

export interface AppstoreControllerFindDetailResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    app: {
      _id: string;
      name: string;
      description?: string[];
      introduction?: string;
      clientDescription?: string;
      unitPrice: number;
      codeName: "ai-coach" | "ai-global-coordinator" | "ai-call-manager";
      status: "PENDING" | "PROCESSING" | "APPROVED" | "ACTIVE" | "INACTIVE";
      thumbnailPath?: string;
      detailDescriptionPath?: string;
      appSettings?: {
        isApproved: boolean;
        isSetupCompleted: boolean;
        isUsingReservation?: boolean;
        settings?: AiCoachResponse | AiGlobalCoordinatorResponse | AiCallManagerResponse | null;
        modifiedAt?: string;
        modifierName?: string;
      };
      subscription?: {
        isActive: boolean;
        activatedAt?: string;
        inactivatedAt?: string;
      };
      history?: {
        /** 병원 ID */
        hospitalID: string;
        /** 앱 ID */
        appID: string;
        /** 상태: REQUESTED(신청) / APPROVED(승인됨) */
        status: string;
        /** REQUESTED(신청) 최초 진입 시 */
        requestedAt?: string;
        /** 신청자명 */
        requesterName?: string;
        /** 연락처 */
        requesterPhone?: string;
        /** 신청자의 로그인 ID (일렉트론 로그인 ID) */
        requesterLoginID?: string;
        /** 사용안함 처리 여부 */
        isRemoved?: boolean;
        /** 사용 취소 요청자명 */
        cancelerName?: string;
        /** 사용 취소 요청자 연락처 */
        cancelerPhone?: string;
        /** 사용 취소 요청자 로그인 ID (일렉트론 로그인 ID) */
        cancelerLoginID?: string;
        /** 취소 요청 시점 */
        cancelRequestedAt?: string;
      };
      modifier?: {
        userID: string;
        name: string;
        realName: string;
        type?: number;
        jobType?: string;
      };
      reservation?: {
        setting: {
          _id: string;
          isSample?: boolean;
          possibleTimes: {
            isSelected: boolean;
            index: number;
            startedAt: string;
            endedAt: string;
          }[];
          hospitalID: string;
          createdAt: string;
          updatedAt: string;
          groupModifiedAt?: string;
          groupModifierID?: {
            _id: string;
            name: string;
            realName: string;
            type?: number;
            jobType?: string;
          } | null;
          columnModifiedAt?: string;
          columnModifierID?: {
            _id: string;
            name: string;
            realName: string;
            type?: number;
            jobType?: string;
          } | null;
          possibleTimesModifiedAt?: string;
          possibleTimesModifierID?: {
            _id: string;
            name: string;
            realName: string;
            type?: number;
            jobType?: string;
          } | null;
          aiSettingModifiedAt?: string;
          aiSettingModifierID?: {
            _id: string;
            name: string;
            realName: string;
            type?: number;
            jobType?: string;
          } | null;
        };
        group: {
          _id: string;
          isSample?: boolean;
          isAi: boolean;
          title: string;
          hospitalID: string;
          usingCustomAIImmediateCreate?: boolean;
          messageAIImmediateCreate?: string;
          messageAIImmediateCreateHistoryID?: string | Record<string, any>;
          customMessageAIImmediateCreate?: string;
          customMessageAIImmediateCreateHistoryID?: string | Record<string, any>;
          usingCustomAIConfirmation?: boolean;
          messageAIConfirmation?: string;
          messageAIConfirmationHistoryID?: string | Record<string, any>;
          customMessageAIConfirmation?: string;
          customMessageAIConfirmationHistoryID?: string | Record<string, any>;
          usingCustomAIRemove?: boolean;
          messageAIRemove?: string;
          messageAIRemoveHistoryID?: string | Record<string, any>;
          customMessageAIRemove?: string;
          customMessageAIRemoveHistoryID?: string | Record<string, any>;
        } | null;
        column: {
          _id: string;
          isSample?: boolean;
          isAi: boolean;
          hospitalID: string;
          title: string;
          aiSameDayBlockType?: string;
          aiSameDayBlockDuration?: number;
          aiPossibleCreateRange?: number;
          aiUsingDefaultAppInterval?: boolean;
          aiAppInterval?: number;
          aiAppTimeIntervals?: string[];
          aiAppMaxCapacity?: number;
        } | null;
      };
      trial?: {
        /** 체험판 사용 가능 여부 */
        isAvailable: boolean;
        /** 체험판 제목 텍스트 */
        trialTitle?: string | null;
        /** 체험판 본문 텍스트 */
        trialBody?: string | null;
        /** 체험판 혜택 조건 */
        benefit?: {
          /** 최대 할인 금액 (원) */
          amountOff: number;
          /** 할인율 (%) */
          percentOff: number;
          /** 설명 */
          description?: string | null;
          /** 체험 기간 (일) */
          durationDays: number;
        };
      };
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerUpdateSettingsBodyRequest {
  /** 앱 ID */
  appID: string;
  /** 병원 ID */
  hospitalID: string;
  /** 앱별 설정 객체 (앱 codeName에 따라 서버에서 검증) */
  settings:
    | ({
        codeName: "ai-coach";
      } & AiCoach)
    | ({
        codeName: "ai-global-coordinator";
      } & AiGlobalCoordinator)
    | ({
        codeName: "ai-call-manager";
      } & AiCallManager);
}

export interface AiCoach {
  /** AI 자동 답변 시점 - 단위 : 분 */
  automaticResponseIntervalMinutes?: number;
  /** 운영시간 기반 시간대별 자동응대 정책 - 미설정 시 automaticResponseIntervalMinutes 단일값 동작 */
  automaticResponsePolicy?: {
    /** 운영시간 내 정책 */
    within: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
    /** 운영시간 외(퇴근 후·휴무일) 정책 */
    outside: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
  };
  /** AI 자동 답변 적용 대상 - 전체 채널 적용 여부 */
  automaticResponseAppliedToAllChannels: boolean;
  /** AI 응대 안내문구 사용 여부 */
  isUsingAiResponseNotice?: boolean;
  /**
   * AI 응대 안내문구 - 기본값 : 안녕하세요. AI 상담사입니다. 빠른 상담을 위해 제가 먼저 도와드릴게요.
   * 확인이 필요한 내용은 담당자에게 전달해 드리겠습니다.
   * @minLength 1
   * @maxLength 200
   */
  aiResponseNoticeMessage?: string;
  /** AI 자동 답변 적용 대상 - 채널 목록, 저장 어떻게 할지 안정해짐 */
  automaticResponseAppliedChannels: {
    _id: string;
    type: "afterdoc" | "ikakao" | "line" | "instagram" | "talktalk" | "wechat" | "whatsapp";
    enabled: boolean;
  }[];
  /** 앱 코드명 (Swagger 식별용, DB 저장 안됨) */
  codeName: "ai-coach";
}

export interface AiGlobalCoordinator {
  /** 부재 시 외국어로 자동 답변 여부 - 모든 언어 적용 여부 */
  automaticResponseAppliedToAllLanguages?: boolean;
  automaticResponseIntervalMinutes: number;
  /** 운영시간 기반 시간대별 자동응대 정책 - 미설정 시 automaticResponseIntervalMinutes 단일값 동작 */
  automaticResponsePolicy?: {
    /** 운영시간 내 정책 */
    within: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
    /** 운영시간 외(퇴근 후·휴무일) 정책 */
    outside: {
      /** 해당 시간대 AI 근무 여부 - false: 언어식별 외 미동작(과금 없음) */
      isWorking: boolean;
      /**
       * 자동발송 대기 분 - null: 자동 응대 안 함(추천 답변만 생성, 자동발송 없음)
       * @min 0
       */
      intervalMinutes: number | null;
    };
  };
  /** 자동 응대할 언어 설정 목록, languageID 모음. */
  automaticResponseAppliedLanguages: string[];
  /** 앱 코드명 (Swagger 식별용, DB 저장 안됨) */
  codeName: "ai-global-coordinator";
}

export interface AiCallManager {
  /** 병원 ID */
  hospitalId?: string;
  /** 부재 시 AI 전화 응대 시점 (초, 기본값 10) */
  autoResponseSecond?: number;
  /**
   * 직접 통화 기록 사용 여부 (true: 직접 기록, false: AI/시스템 기록 등, 기본값 true)
   * @default true
   */
  isUsingDirectCallRecord?: boolean;
  /** 전화번호 매핑 목록 */
  phoneNumberMappings?: {
    /** 매핑 고유 ID */
    _id: string;
    /** 매핑 별칭 (Admin 관리용) */
    name?: string;
    /** 병원 대표번호 (E.164) */
    hospitalMainNumber: string;
    /** Twilio AI 수신번호 (E.164) */
    twilioIncomingPhoneNumber: string;
    /** 직원 수신 전화번호 목록 (E.164[]) */
    phoneLineNumbers: string[];
    /** 알림 지정 대상(전화 문의 담당자) 계정 ID 목록 */
    notificationRecipientIds?: string[];
    /** 매핑 수정일시 */
    updatedAt?: string | null;
  }[];
  /** 앱 코드명 (Swagger 식별용, DB 저장 안됨) */
  codeName: "ai-call-manager";
}

export interface AppstoreControllerUpdateSettingsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    appSettings: {
      isApproved: boolean;
      isSetupCompleted: boolean;
      isUsingReservation: boolean;
      /** 앱별 설정 객체 */
      settings: Record<string, any>;
    };
    reservation?: {
      setting: {
        _id: string;
        isSample?: boolean;
        possibleTimes: {
          isSelected: boolean;
          index: number;
          startedAt: string;
          endedAt: string;
        }[];
        hospitalID: string;
        createdAt: string;
        updatedAt: string;
        groupModifiedAt?: string;
        groupModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
        columnModifiedAt?: string;
        columnModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
        possibleTimesModifiedAt?: string;
        possibleTimesModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
        aiSettingModifiedAt?: string;
        aiSettingModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
      };
      group: {
        _id: string;
        isSample?: boolean;
        isAi: boolean;
        title: string;
        hospitalID: string;
        usingCustomAIImmediateCreate?: boolean;
        messageAIImmediateCreate?: string;
        messageAIImmediateCreateHistoryID?: string | Record<string, any>;
        customMessageAIImmediateCreate?: string;
        customMessageAIImmediateCreateHistoryID?: string | Record<string, any>;
        usingCustomAIConfirmation?: boolean;
        messageAIConfirmation?: string;
        messageAIConfirmationHistoryID?: string | Record<string, any>;
        customMessageAIConfirmation?: string;
        customMessageAIConfirmationHistoryID?: string | Record<string, any>;
        usingCustomAIRemove?: boolean;
        messageAIRemove?: string;
        messageAIRemoveHistoryID?: string | Record<string, any>;
        customMessageAIRemove?: string;
        customMessageAIRemoveHistoryID?: string | Record<string, any>;
      } | null;
      column: {
        _id: string;
        isSample?: boolean;
        isAi: boolean;
        hospitalID: string;
        title: string;
        aiSameDayBlockType?: string;
        aiSameDayBlockDuration?: number;
        aiPossibleCreateRange?: number;
        aiUsingDefaultAppInterval?: boolean;
        aiAppInterval?: number;
        aiAppTimeIntervals?: string[];
        aiAppMaxCapacity?: number;
      } | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerUpdateReservationSettingsBodyRequest {
  /** 앱 ID */
  appID: string;
  /** 병원 ID */
  hospitalID: string;
  /** 앱 개별 예약 기능 사용 여부 */
  isUsingReservation?: boolean;
  /** 샘플 데이터 여부 (true면 예약 설정을 새로 생성) */
  isSample?: boolean;
  reservation?: {
    setting?: {
      /** v2ReservationSetting 문서 ID */
      _id: string;
      possibleTimes?: {
        isSelected: boolean;
        index: number;
        startedAt: string;
        endedAt: string;
      }[];
    };
    group?: {
      /** (required) group id */
      _id: string;
      /** (required) 병원 ID */
      hospitalID: string;
      /** AI 예약 생성 즉시 메시지 커스텀 사용 여부 */
      usingCustomAIImmediateCreate: boolean;
      /** AI 예약 생성 즉시 메시지 커스텀 메시지 */
      customMessageAIImmediateCreate: string;
      /** AI 예약 확정 메시지 커스텀 사용 여부 */
      usingCustomAIConfirmation: boolean;
      /** AI 예약 확정 메시지 커스텀 메시지 */
      customMessageAIConfirmation: string;
      /** AI 예약 삭제 메시지 커스텀 사용 여부 */
      usingCustomAIRemove: boolean;
      /** AI 예약 삭제 메시지 커스텀 메시지 */
      customMessageAIRemove: string;
    };
    column?: {
      /** v2ReservationColumn 문서 ID */
      _id: string;
      /** (required) 병원 ID */
      hospitalID: string;
      /** AI 생성 시작 단위 - hour/day */
      aiSameDayBlockType?: string;
      /** AI 예약생성 가능 범위 : 시작 */
      aiSameDayBlockDuration?: number;
      /** AI 예약생성 가능 범위 : 종료 */
      aiPossibleCreateRange?: number;
      /** AI 기본 앱 간격 사용 여부 */
      aiUsingDefaultAppInterval?: boolean;
      /** AI 앱 간격 */
      aiAppInterval?: number;
      /** AI 앱 시간 간격 배열 */
      aiAppTimeIntervals?: string[];
      /** AI 앱 최대 수용 인원 */
      aiAppMaxCapacity?: number;
    };
  } | null;
}

export interface AppstoreControllerUpdateReservationSettingsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    isUsingReservation?: boolean;
    reservation: {
      setting: {
        _id: string;
        isSample?: boolean;
        possibleTimes: {
          isSelected: boolean;
          index: number;
          startedAt: string;
          endedAt: string;
        }[];
        hospitalID: string;
        createdAt: string;
        updatedAt: string;
        groupModifiedAt?: string;
        groupModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
        columnModifiedAt?: string;
        columnModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
        possibleTimesModifiedAt?: string;
        possibleTimesModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
        aiSettingModifiedAt?: string;
        aiSettingModifierID?: {
          _id: string;
          name: string;
          realName: string;
          type?: number;
          jobType?: string;
        } | null;
      };
      group: {
        _id: string;
        isSample?: boolean;
        isAi: boolean;
        title: string;
        hospitalID: string;
        usingCustomAIImmediateCreate?: boolean;
        messageAIImmediateCreate?: string;
        messageAIImmediateCreateHistoryID?: string | Record<string, any>;
        customMessageAIImmediateCreate?: string;
        customMessageAIImmediateCreateHistoryID?: string | Record<string, any>;
        usingCustomAIConfirmation?: boolean;
        messageAIConfirmation?: string;
        messageAIConfirmationHistoryID?: string | Record<string, any>;
        customMessageAIConfirmation?: string;
        customMessageAIConfirmationHistoryID?: string | Record<string, any>;
        usingCustomAIRemove?: boolean;
        messageAIRemove?: string;
        messageAIRemoveHistoryID?: string | Record<string, any>;
        customMessageAIRemove?: string;
        customMessageAIRemoveHistoryID?: string | Record<string, any>;
      } | null;
      column: {
        _id: string;
        isSample?: boolean;
        isAi: boolean;
        hospitalID: string;
        title: string;
        aiSameDayBlockType?: string;
        aiSameDayBlockDuration?: number;
        aiPossibleCreateRange?: number;
        aiUsingDefaultAppInterval?: boolean;
        aiAppInterval?: number;
        aiAppTimeIntervals?: string[];
        aiAppMaxCapacity?: number;
      } | null;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerRequestSubscriptionBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 구독 신청할 앱 ID */
  appID: string;
  /** 신청자명 */
  requesterName: string;
  /** 신청자 연락처 */
  requesterPhone: string;
  /** 신청자 로그인 ID */
  requesterLoginID: string;
}

export interface AppstoreControllerRequestSubscriptionResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    history: {
      _id: string;
      hospitalID: string;
      appID: string;
      status: string;
      requestedAt?: string;
      requesterName?: string;
      requesterPhone?: string;
      requesterLoginID?: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerUpdateSubscriptionRequesterBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 앱 ID */
  appID: string;
  /** 신청자명 */
  requesterName: string;
  /** 신청자 연락처 */
  requesterPhone: string;
  /** 신청자 로그인 ID (일렉트론 로그인 ID) */
  requesterLoginID: string;
}

export interface AppstoreControllerUpdateSubscriptionRequesterResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    history: {
      _id: string;
      hospitalID: string;
      appID: string;
      status: string;
      requestedAt?: string;
      requesterName?: string;
      requesterPhone?: string;
      requesterLoginID?: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerToggleSubscriptionBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 토글할 앱 ID */
  appID: string;
  /** 활성화 여부 (true: 켜기, false: 끄기) */
  isActive: boolean;
  /** 사용 취소 요청자명 */
  cancelerName?: string;
  /** 사용 취소 요청자 연락처 */
  cancelerPhone?: string;
  /** 사용 취소 요청자 로그인 ID */
  cancelerLoginID?: string;
}

export interface AppstoreControllerToggleSubscriptionResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    subscription: {
      _id: string;
      hospitalID: string;
      appID: string;
      isActive: boolean;
      activatedAt?: string;
      inactivatedAt?: string;
      modifierID?: string;
      isRemoved?: boolean;
    };
    deactivatedDependents?: {
      _id: string;
      hospitalID: string;
      appID: string;
      appName: string;
      isActive: boolean;
      inactivatedAt?: string;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerGetProvisionalReservationCountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 가예약 건수 */
    count: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerGetCallManagerNeedCheckCountResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 확인 필요 건수 */
    count: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerGetAppUsageAlertSettingResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 이름 */
    name?: string | null;
    /** 전화번호 */
    phone?: string | null;
    /** 한도금액 */
    amount: number;
    /** 사용 금액 */
    usedAmount: number;
    /** 초과 여부 */
    isExceeded: boolean;
    /** 생성일 */
    createdAt: string;
    /** 수정일 */
    updatedAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface AppstoreControllerCreateAppUsageAlertSettingBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 이름 */
  name?: string | null;
  /** 전화번호 */
  phone?: string | null;
  /** 한도금액 */
  amount: number;
}

export interface AppstoreControllerCreateAppUsageAlertSettingResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** ID */
    _id?: string | null;
    /** 병원 ID */
    hospitalID?: string | null;
    /** 이름 */
    name?: string | null;
    /** 전화번호 */
    phone?: string | null;
    /** 한도금액 */
    amount?: number | null;
    /** 생성일 */
    createdAt?: string | null;
    /** 수정일 */
    updatedAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

/** @example {"hospitalID":"6732be1387ee3809f9d76383","invoiceID":"6732be1387ee3809f9d76383","alertType":"USAGE_LIMIT_EXCEEDED","discountPolicyID":"6732be1387ee3809f9d76383","appID":"6732be1387ee3809f9d76383","limitAmount":1000000} */
export interface AppstoreServiceNoticeControllerSendServiceNoticeBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** invoice ID */
  invoiceID: string;
  /** alert type */
  alertType:
    | "USAGE_LIMIT_EXCEEDED"
    | "FREE_TRIAL_ENDED_BY_MAX_AMOUNT"
    | "FREE_TRIAL_ENDING_3_DAYS"
    | "FREE_TRIAL_ENDED_BY_PERIOD"
    | "DISCOUNT_ENDING_3_DAYS"
    | "DISCOUNT_ENDED"
    | "APP_APPROVED"
    | "BILL_PAYMENT_FAILED";
  /** discount policy ID */
  discountPolicyID?: string | null;
  /** app ID */
  appID?: string | null;
  /** 한도금액 (USAGE_LIMIT_EXCEEDED 전용, 한도 상향 재발송 판정에 사용) */
  limitAmount?: number | null;
}

export interface AppstoreServiceNoticeControllerSendServiceNoticeResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 성공 여부 */
    success: boolean;
    /** AppUsageAlertHistory ID */
    historyId?: string | null;
    /** 생성일시 */
    createdAt?: string | null;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export type AppstoreControllerFindStoreBannersData = AppstoreControllerFindStoreBannersResponse;

export interface AppstoreControllerFindParams {
  /**
   * 구독 상태 필터: ALL(전체), PENDING(대기중), PROCESSING(처리중), APPROVED(승인됨), ACTIVE(활성), INACTIVE(비활성)
   * @default "ALL"
   */
  status?: "ALL" | "PENDING" | "PROCESSING" | "APPROVED" | "ACTIVE" | "INACTIVE";
}

export type AppstoreControllerFindData = AppstoreControllerFindListResponse;

export interface AppstoreControllerFindDetailParams {
  /** 앱 ID */
  appID: string;
}

export type AppstoreControllerFindDetailData = AppstoreControllerFindDetailResponse;

export type AppstoreControllerUpdateSettingsData = AppstoreControllerUpdateSettingsResponse;

export type AppstoreControllerUpdateReservationSettingsData = AppstoreControllerUpdateReservationSettingsResponse;

export type AppstoreControllerRequestSubscriptionData = AppstoreControllerRequestSubscriptionResponse;

export type AppstoreControllerUpdateSubscriptionRequesterData = AppstoreControllerUpdateSubscriptionRequesterResponse;

export type AppstoreControllerToggleSubscriptionData = AppstoreControllerToggleSubscriptionResponse;

export type AppstoreControllerGetProvisionalReservationCountData =
  AppstoreControllerGetProvisionalReservationCountResponse;

export type AppstoreControllerGetCallManagerNeedCheckCountData = AppstoreControllerGetCallManagerNeedCheckCountResponse;

export interface AppstoreControllerGetAppUsageAlertSettingParams {
  /** 병원 ID */
  hospitalID: string;
}

export type AppstoreControllerGetAppUsageAlertSettingData = AppstoreControllerGetAppUsageAlertSettingResponse;

export type AppstoreControllerCreateAppUsageAlertSettingData = AppstoreControllerCreateAppUsageAlertSettingResponse;

export type AppstoreServiceNoticeControllerSendServiceNoticeData =
  AppstoreServiceNoticeControllerSendServiceNoticeResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description AI 앱스토어 메인 배너 목록을 조회합니다
     *
     * @tags V3-Appstore
     * @name AppstoreControllerFindStoreBanners
     * @summary 앱스토어 배너 목록 조회
     * @request GET:/v3/api/appstore/apps/banners
     * @secure
     * @response `200` `AppstoreControllerFindStoreBannersData` success
     */
    appstoreControllerFindStoreBanners: (params: RequestParams = {}) =>
      this.request<AppstoreControllerFindStoreBannersData, any>({
        path: `/v3/api/appstore/apps/banners`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 앱스토어 목록을 조회합니다 (모든 앱 모아보기)
     *
     * @tags V3-Appstore
     * @name AppstoreControllerFind
     * @summary 앱스토어 목록 조회
     * @request GET:/v3/api/appstore/apps
     * @secure
     * @response `200` `AppstoreControllerFindData` success
     */
    appstoreControllerFind: (query: AppstoreControllerFindParams, params: RequestParams = {}) =>
      this.request<AppstoreControllerFindData, any>({
        path: `/v3/api/appstore/apps`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 앱스토어 개별 앱 상세 정보를 조회합니다
     *
     * @tags V3-Appstore
     * @name AppstoreControllerFindDetail
     * @summary 앱스토어 개별 앱 상세조회
     * @request GET:/v3/api/appstore/apps/detail
     * @secure
     * @response `200` `AppstoreControllerFindDetailData` success
     */
    appstoreControllerFindDetail: (query: AppstoreControllerFindDetailParams, params: RequestParams = {}) =>
      this.request<AppstoreControllerFindDetailData, any>({
        path: `/v3/api/appstore/apps/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 앱 설정을 저장/수정합니다. 앱 codeName에 따라 settings가 자동 검증됩니다.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerUpdateSettings
     * @summary 앱 설정 저장
     * @request PUT:/v3/api/appstore/apps/settings
     * @secure
     * @response `200` `AppstoreControllerUpdateSettingsData` success
     */
    appstoreControllerUpdateSettings: (data: AppstoreControllerUpdateSettingsBodyRequest, params: RequestParams = {}) =>
      this.request<AppstoreControllerUpdateSettingsData, any>({
        path: `/v3/api/appstore/apps/settings`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 예약 관련 설정을 저장/수정합니다. AI_COACH, AI_CALL_MANAGER만 지원.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerUpdateReservationSettings
     * @summary 앱 예약 설정 저장
     * @request PUT:/v3/api/appstore/apps/settings/reservation
     * @secure
     * @response `200` `AppstoreControllerUpdateReservationSettingsData` success
     */
    appstoreControllerUpdateReservationSettings: (
      data: AppstoreControllerUpdateReservationSettingsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreControllerUpdateReservationSettingsData, any>({
        path: `/v3/api/appstore/apps/settings/reservation`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 앱 도입 신청 - 앱 구독을 신청합니다. 백오피스 어드민 승인 후 사용 가능
     *
     * @tags V3-Appstore
     * @name AppstoreControllerRequestSubscription
     * @summary 앱 구독 신청
     * @request POST:/v3/api/appstore/subscriptions/request
     * @secure
     * @response `200` `AppstoreControllerRequestSubscriptionData` success
     */
    appstoreControllerRequestSubscription: (
      data: AppstoreControllerRequestSubscriptionBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreControllerRequestSubscriptionData, any>({
        path: `/v3/api/appstore/subscriptions/request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 앱 도입 신청에 대한 신청자 정보 변경
     *
     * @tags V3-Appstore
     * @name AppstoreControllerUpdateSubscriptionRequester
     * @summary 앱 구독 신청자 정보 수정
     * @request PATCH:/v3/api/appstore/subscriptions/request
     * @secure
     * @response `200` `AppstoreControllerUpdateSubscriptionRequesterData` success
     */
    appstoreControllerUpdateSubscriptionRequester: (
      data: AppstoreControllerUpdateSubscriptionRequesterBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreControllerUpdateSubscriptionRequesterData, any>({
        path: `/v3/api/appstore/subscriptions/request`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 앱 구독 토글 - 승인 완료된 앱의 구독을 활성화/비활성화합니다.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerToggleSubscription
     * @summary 앱 구독 토글
     * @request POST:/v3/api/appstore/subscriptions/toggle
     * @secure
     * @response `200` `AppstoreControllerToggleSubscriptionData` success
     */
    appstoreControllerToggleSubscription: (
      data: AppstoreControllerToggleSubscriptionBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreControllerToggleSubscriptionData, any>({
        path: `/v3/api/appstore/subscriptions/toggle`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 탭 가예약 건수 개수를 조회합니다.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerGetProvisionalReservationCount
     * @summary 가예약 건수 조회
     * @request GET:/v3/api/appstore/provisional-reservation/count
     * @secure
     * @response `200` `AppstoreControllerGetProvisionalReservationCountData` success
     */
    appstoreControllerGetProvisionalReservationCount: (params: RequestParams = {}) =>
      this.request<AppstoreControllerGetProvisionalReservationCountData, any>({
        path: `/v3/api/appstore/provisional-reservation/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 탭 Call Manager 확인 필요 알림 개수를 조회합니다.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerGetCallManagerNeedCheckCount
     * @summary Call Manager 확인 필요 개수 조회
     * @request GET:/v3/api/appstore/call-manager/need-check/count
     * @secure
     * @response `200` `AppstoreControllerGetCallManagerNeedCheckCountData` success
     */
    appstoreControllerGetCallManagerNeedCheckCount: (params: RequestParams = {}) =>
      this.request<AppstoreControllerGetCallManagerNeedCheckCountData, any>({
        path: `/v3/api/appstore/call-manager/need-check/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 사용 알림 설정, 초과 여부를 조회합니다.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerGetAppUsageAlertSetting
     * @summary AI 사용 알림 설정 조회
     * @request GET:/v3/api/appstore/usage-alert/setting
     * @secure
     * @response `200` `AppstoreControllerGetAppUsageAlertSettingData` success
     */
    appstoreControllerGetAppUsageAlertSetting: (
      query: AppstoreControllerGetAppUsageAlertSettingParams,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreControllerGetAppUsageAlertSettingData, any>({
        path: `/v3/api/appstore/usage-alert/setting`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description AI 사용 알림 설정을 생성합니다.
     *
     * @tags V3-Appstore
     * @name AppstoreControllerCreateAppUsageAlertSetting
     * @summary AI 사용 알림 설정 생성
     * @request POST:/v3/api/appstore/usage-alert/setting
     * @secure
     * @response `200` `AppstoreControllerCreateAppUsageAlertSettingData` success
     */
    appstoreControllerCreateAppUsageAlertSetting: (
      data: AppstoreControllerCreateAppUsageAlertSettingBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreControllerCreateAppUsageAlertSettingData, any>({
        path: `/v3/api/appstore/usage-alert/setting`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description invoice, billing 관련 service-notice를 발송합니다.
     *
     * @tags V3-Appstore
     * @name AppstoreServiceNoticeControllerSendServiceNotice
     * @summary invoice, billing 관련 service-notice를 발송합니다.
     * @request POST:/v3/api/appstore/service-notice
     * @secure
     * @response `200` `AppstoreServiceNoticeControllerSendServiceNoticeData` success
     */
    appstoreServiceNoticeControllerSendServiceNotice: (
      data: AppstoreServiceNoticeControllerSendServiceNoticeBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<AppstoreServiceNoticeControllerSendServiceNoticeData, any>({
        path: `/v3/api/appstore/service-notice`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
